import { axiosClient } from "@/shared/api/axios-client";

/** Rol del sistema o personalizado (AspNetRoles vía RoleManager). */
export interface RolAdmin {
  id: string;
  nombre: string;
  descripcion: string | null;
  /** True para los 7 roles del sistema · no se pueden renombrar ni eliminar. */
  esSistema: boolean;
  /** Cantidad de usuarios que tienen asignado el rol. */
  usuariosCount: number;
  /** Códigos de permiso concedidos al rol (RBAC · Ruta B). */
  permisos: string[];
}

/** Un permiso del catálogo (agrupado para la UI). */
export interface PermisoCatalogo {
  codigo: string;
  grupo: string;
  descripcion: string;
  /** Personalizado y sin cablear · asignable pero no otorga acceso todavía. */
  pendienteCablear: boolean;
}

export interface CrearRolInput {
  nombre: string;
  descripcion: string | null;
}

export interface EditarRolInput {
  nombre: string;
  descripcion: string | null;
}

export async function listarRolesAdmin(): Promise<RolAdmin[]> {
  const { data } = await axiosClient.get<RolAdmin[]>("/api/admin/roles");
  return data;
}

export async function crearRol(input: CrearRolInput): Promise<RolAdmin> {
  const { data } = await axiosClient.post<RolAdmin>("/api/admin/roles", input);
  return data;
}

export async function editarRol(id: string, input: EditarRolInput): Promise<RolAdmin> {
  const { data } = await axiosClient.put<RolAdmin>(`/api/admin/roles/${id}`, input);
  return data;
}

export async function eliminarRol(id: string): Promise<void> {
  await axiosClient.delete(`/api/admin/roles/${id}`);
}

export async function listarPermisos(): Promise<PermisoCatalogo[]> {
  const { data } = await axiosClient.get<PermisoCatalogo[]>("/api/admin/permisos");
  return data;
}

export async function asignarPermisosARol(id: string, permisos: string[]): Promise<RolAdmin> {
  const { data } = await axiosClient.put<RolAdmin>(`/api/admin/roles/${id}/permisos`, { permisos });
  return data;
}
